import React from 'react';
import { translate } from 'react-i18next';
import {Form, Button, Label, Icon, Header, Input} from 'semantic-ui-react'

import SurveyButtons from './SurveyButtons.js';
import {colors} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    unitButton: {
        border: '1px solid ' + colors.themeBlue,
        backgroundColor: '#fff',
        color: colors.themeLightBlue,
    },
    unitButtonActive: {
        border: '1px solid ' + colors.themeBlue,
        backgroundColor: colors.themeBlue,
        color: '#fff',
    }
}

const SurveyPageWaist = ({t,
                           surveyPage, 
                           inlineButtons, 
                           value, 
                           unit, 
                           units, 
                           valid, 
                           onChange, 
                           onSubmit, 
                           onSkip, 
                           onSetUnit,
                           pageNum, 
                           numPages}) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>
            <form onSubmit={onSubmit} autoComplete='off'>

                <div style={style.header}>{surveyPage.title}</div>

                {numPages &&
                    <div style={style.pageCount}>
                        {t('page_{{pageNum}}_{{numPages}}',{pageNum, numPages})}
                    </div>
                }


                <div style={style.description}>
                    {surveyPage.description}
                </div>
              
                <div style={style.body}>
                    <div>
                        <Input pattern="[0-9]*" type="text" value={value} placeholder={t('Waist')} autoComplete="off" onChange={onChange} />
                    </div>
                    <br />
                    <Button.Group size='tiny'>
                        {units.map((u)=>(
                            <Button style={u.tag===unit.tag ? style.unitButtonActive : style.unitButton} type="button" key={u.tag} onClick={()=>onSetUnit(u.tag)}>{u.label}</Button>
                        ))}
                    </Button.Group>
               </div>
                <SurveyButtons canSkip={surveyPage.canSkip} onSkip={onSkip} onSubmit={onSubmit} valid={valid} inlineButtons={inlineButtons} />

                {!inlineButtons &&
                    <div style={style.spacer} />       
                }
            </form>

            {/*<pre style={{textAlign: 'left'}}>{JSON.stringify(survey,null,2)}</pre>*/}
        </div>
    </div>
    </div>
);

export default translate('surveys')(SurveyPageWaist);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageWaist.js